<template>
  <div class="result-check">
    <result-check-content
      v-if="resultCheck"
      layout="mobile"
      v-bind="resultCheck"
    />
  </div>
</template>
<script>
import { parseData } from '../api/api'
import ResultCheckContent from '../components/ResultCheckContent'
import { buildResultCheckFromResponse } from '../utils/resultCheckParse'

export default {
  name: 'result-checking-mobile',

  components: {
    ResultCheckContent,
  },

  data() {
    return {
      resultCheck: null,
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      const urlParams = new URLSearchParams(window.location.search)
      const params = Object.fromEntries(urlParams.entries())
      parseData(params).then(({ response }) => {
        this.resultCheck = buildResultCheckFromResponse(response)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.result-check {
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  padding: 20px 10px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
